import React, { useState, useEffect } from 'react';
import AsideLeft from './AppAdminComponents/AsideLeft';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import { getuser } from '../helpers/user.helper';
import { useNavigate, useParams } from "react-router-dom";
import { GetCustomer } from '../services/customer.service';
import { useForm } from "react-hook-form";
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Footer from '../components/Footer';


export default function CustomerDetail() {
    let navigate = useNavigate();
    const [customersArray, setCustomers] = useState(undefined);
    const { register, handleSubmit, watch, errors } = useForm();
    const onSubmit = data => console.log(data);

    let { id } = useParams();

    useEffect(() => {
        let user = getuser();
        //Redireciona caso não esteja logado 
        if (!user) {
            navigate('/login');
        }

        async function fetchData() {
            let customers = await GetCustomer(id);
            setCustomers(customers?.data[0]);
        }

        fetchData();
    }, [])

    let renderLoad = () => {
        return (
            <div className="table-footer text-center">
                <Loader
                    type="ThreeDots"
                    color="#343A40"
                    height={100}
                    width={100}
                    visible={true}
                />
            </div>
        );
    }

    return (
        <>

            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />
                </nav>
                <AsideLeft option="clientes" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Cliente</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* Left col */}
                                <section className="col-lg-12 connectedSortable">
                                    {/* Custom tabs (Charts with tabs)*/}
                                    <div className="card">
                                        <div className="card-header">

                                        </div>
                                        <div className="card-body">
                                            {
                                                !customersArray ?
                                                    renderLoad()
                                                    :
                                                    <div className="tab-content p-0">
                                                        <form onSubmit={handleSubmit(onSubmit)}>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="form-group">
                                                                        <label >Código</label>
                                                                        <input type="text" name="nome" className="form-control" aria-describedby="nome" defaultValue={customersArray.nome} ref={register({ required: true })} />
                                                                        {errors.nome && <span>Campo obrigatório</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <div className="form-group">
                                                                        <label >Cidade</label>
                                                                        <input type="text" name="cidade" className="form-control" id="exampleInputEmail1" defaultValue={customersArray.cidade} aria-describedby="emailHelp" ref={register({ required: true })} />
                                                                        {errors.cidade && <span>Campo obrigatório</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="form-group">
                                                                        <label >CPF</label>
                                                                        <input type="text" name="cpf" className="form-control" aria-describedby="emailHelp" defaultValue={customersArray.cpf} ref={register({ required: true })} />
                                                                        {errors.cpf && <span>Campo obrigatório</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <input type="submit" /> */}
                                                        </form>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    )
}
